import { savedJourneyOpenErrorCopy } from '../data/savedJourneyOpenErrorCopy.js';
import { journeyStageNavigationCopy } from '../data/journeyStageNavigationCopy.js';
import { STAGE_LABELS, journeyStageLabel } from './journeyStageUiText.js';
import { professionalTranslationFor } from '../data/professionalTranslationRuntime.js';
import { sourceRevision } from './translationAssurance.js';

// Independent legacy language maps were never in canonical locale JSON.
// These IDs are reviewable and their corrections are consumed at runtime.
export function buildLegacyPatientUiTranslationRows(locale) {
  const code = String(locale || 'en').toLowerCase().split('-')[0];
  const stageText = journeyStageLabel(code, 1).replace(/\s+1$/, '');
  const collections = [
    { namespace: 'savedJourneyOpenError', contentArea: 'hospital_journeys',
      english: { message: savedJourneyOpenErrorCopy('en') },
      current: { message: savedJourneyOpenErrorCopy(code) } },
    { namespace: 'journeyStageNavigation', contentArea: 'hospital_journeys',
      english: journeyStageNavigationCopy('en'), current: journeyStageNavigationCopy(code) },
    { namespace: 'journeyStageUi', contentArea: 'hospital_journeys',
      english: { stage: STAGE_LABELS.en }, current: { stage: stageText } },
  ];
  return collections.flatMap(({ namespace, contentArea, english, current }) =>
    Object.entries(english).map(([path, sourceText]) => {
      const id = namespace + ':' + path;
      return { id, namespace, path, contentArea, sourceText,
        sourceRevision: sourceRevision(id, sourceText),
        originalText: current[path] || '',
        provenance: professionalTranslationFor(code, namespace, path)
          ? 'professionally approved correction' : 'legacy patient Journey UI map',
        publicationTarget: 'locale' };
    }));
}
